import { IonLabel, IonNote, IonSkeletonText } from '@ionic/react'
import { format, isBefore, parseISO } from 'date-fns'

import { useTasks } from '../../hooks/tasks/queries'
import Avatar from '../../components/avatar'
import {
  ListItem,
  ListItemHeading,
  ListItemSubHeading,
} from '../../components/ui/list-item'
import { getDueString } from '../utils'

type Task = NonNullable<ReturnType<typeof useTasks>['data']>[number]

const today = new Date()

function TaskItem({ task }: { task: Task }) {
  const overdue = task.completedAt
    ? false
    : task.due
    ? isBefore(parseISO(task.due.iso), today)
    : false

  const color = task.completedAt ? 'success' : overdue ? 'danger' : 'secondary'

  return (
    <ListItem routerLink={`/tasks/${task.className}/${task.objectId}`}>
      <Avatar
        user={{
          firstName: task.firstName,
          lastName: task.lastName,
          photo: task.photo,
        }}
      />
      <IonLabel className="ml-4">
        <ListItemHeading>{`${task.firstName} ${task.lastName}`}</ListItemHeading>

        <ListItemSubHeading>
          {`${task.className === 'FollowUp' ? 'Task' : task.className}`}:{' '}
          {task.title ? <span>{task.title}</span> : ''}
        </ListItemSubHeading>

        <ListItemSubHeading>
          Created On: {format(parseISO(task.createdAt.iso), 'MM/dd/yyyy')}
        </ListItemSubHeading>
      </IonLabel>
      <IonNote className="ml-2" slot="end" color={color}>
        <div className="text-xs">{getDueString(task)}</div>
      </IonNote>
    </ListItem>
  )
}

function TaskItemSkeleton() {
  return (
    <ListItem>
      <div className="border-ion-color-secondary flex size-9 flex-col items-center justify-center overflow-hidden rounded-full border">
        <IonSkeletonText animated className="m-0 size-full"></IonSkeletonText>
      </div>

      <IonLabel className="ml-2">
        <h3 className="w-2/3">
          <IonSkeletonText className="m-0 w-full leading-none"></IonSkeletonText>
        </h3>

        <p className="w-2/5">
          <IonSkeletonText className="m-0 w-full leading-none"></IonSkeletonText>
        </p>

        <p className="w-2/5">
          <IonSkeletonText className="m-0 w-full leading-none"></IonSkeletonText>
        </p>
      </IonLabel>
    </ListItem>
  )
}

export { TaskItem, TaskItemSkeleton }
